import React from 'react';
import Pagination from 'react-bootstrap/Pagination';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

interface CustomPaginationProps {
	totalData: number;
	limit: number;
	page: number;
	setCurrentPage: any;
}

const PaginationBox: React.FC<CustomPaginationProps> = ({
	totalData,
	limit,
	page,
	setCurrentPage,
}) => {
	const { translate } = useTranslate();
	const totalPages = Math.ceil(totalData / limit);
	const handlePageChange = (page: number) => {
		setCurrentPage(page);
	};

	const renderPaginationItems = () => {
		const items = [];
		let startPage = Math.max(1, page - 3);
		const endPage = Math.min(totalPages, startPage + 6);

		if (endPage - startPage < 6) {
			startPage = Math.max(1, endPage - 6);
		}

		for (let pageNum = startPage; pageNum <= endPage; pageNum++) {
			items.push(
				<Pagination.Item
					key={pageNum}
					active={pageNum === page}
					onClick={() => handlePageChange(pageNum)}
				>
					{pageNum}
				</Pagination.Item>,
			);
		}
		return items;
	};

	return (
		<div className="pagination-box mt-4">
			<Pagination className="justify-content-center gap-2 mb-0">
				{page > 1 && (
					<Pagination.Prev onClick={() => handlePageChange(page - 1)} className="page-back">
						<i className="ri-arrow-left-s-line"></i> {translate('Common.previous')}
					</Pagination.Prev>
				)}
				{totalPages > 1 && renderPaginationItems()}
				{/* <Pagination.Ellipsis /> */}
				{page < totalPages && (
					<Pagination.Next onClick={() => handlePageChange(page + 1)} className="page-next">
						{translate('Common.next')} <i className="ri-arrow-right-s-line"></i>
					</Pagination.Next>
				)}
			</Pagination>
		</div>
	);
};

export default PaginationBox;
